<img ngSrc="/assets/icon/profile.svg" width="22" height="22" alt="Lyceo logo" />
